'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _templateObject = _taggedTemplateLiteral(['\n  display: flex;\n  flex-direction: row;\n'], ['\n  display: flex;\n  flex-direction: row;\n']),
    _templateObject2 = _taggedTemplateLiteral(['\n  background-color: ', ';\n  border: solid ', ' ', ';\n  border-radius: ', ';\n  width: ', '\n  cursor: pointer;\n  &:focus {\n    box-shadow: ', '\n    border: none;\n    outline: 0;\n  }\n  &::-moz-focus-inner {\n    border: 0;\n  }\n'], ['\n  background-color: ', ';\n  border: solid ', ' ', ';\n  border-radius: ', ';\n  width: ', '\n  cursor: pointer;\n  &:focus {\n    box-shadow: ', '\n    border: none;\n    outline: 0;\n  }\n  &::-moz-focus-inner {\n    border: 0;\n  }\n']),
    _templateObject3 = _taggedTemplateLiteral(['\n  padding: ', ';\n  color: ', ';\n  cursor: ', ';\n  font-family: ', ';\n  margin: 0;\n'], ['\n  padding: ', ';\n  color: ', ';\n  cursor: ', ';\n  font-family: ', ';\n  margin: 0;\n']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _Icon = require('../Icon');

var _Icon2 = _interopRequireDefault(_Icon);

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
}

var Wrapper = _styledComponents2.default.div(_templateObject);

var ControlButton = _styledComponents2.default.button(_templateObject2, function (_ref) {
  var theme = _ref.theme;
  return theme.color.primaryBg;
}, (0, _polished.rem)(1), function (_ref2) {
  var theme = _ref2.theme;
  return theme.separatorColor;
}, function (_ref3) {
  var theme = _ref3.theme;
  return theme.largeBorderRadius;
}, (0, _polished.rem)(50), function (_ref4) {
  var theme = _ref4.theme;
  return theme.focusShadow;
});

var PageNumber = _styledComponents2.default.p(_templateObject3, (0, _polished.rem)(10), function (_ref5) {
  var active = _ref5.active,
      theme = _ref5.theme;
  return active === true ? theme.color.primary : 'black';
}, function (_ref6) {
  var disabled = _ref6.disabled;
  return disabled ? 'not-allowed' : 'pointer';
}, function (_ref7) {
  var theme = _ref7.theme;
  return theme.fontFamily;
});

function PageNavigator(props) {
  var activePage = parseInt(props.activePage);
  var end = parseInt(props.end);
  return _react2.default.createElement(Wrapper, null, _react2.default.createElement(ControlButton, {
    left: true,
    onClick: function onClick() {
      return props.onDecrease();
    },
    disabled: activePage === 1
  }, _react2.default.createElement(_Icon2.default, {
    size: 'xs',
    name: 'arrow-left'
  })), _react2.default.createElement(PageNumber, null, activePage, 'z', end), _react2.default.createElement(ControlButton, {
    onClick: function onClick() {
      return props.onIncrease();
    },
    disabled: activePage === end
  }, _react2.default.createElement(_Icon2.default, {
    size: 'xs',
    name: 'arrow-right'
  })));
}

PageNavigator.propTypes = {
  activePage: _propTypes2.default.number.isRequired,
  end: _propTypes2.default.number.isRequired,
  onIncrease: _propTypes2.default.func.isRequired,
  onDecrease: _propTypes2.default.func.isRequired
};
exports.default = PageNavigator;
PageNavigator.__docgenInfo = [{
  'description': '',
  'displayName': 'PageNavigator',
  'methods': [],
  'props': {
    'activePage': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    },
    'end': {
      'type': {
        'name': 'number'
      },
      'required': true,
      'description': ''
    },
    'onIncrease': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    },
    'onDecrease': {
      'type': {
        'name': 'func'
      },
      'required': true,
      'description': ''
    }
  }
}];

if (typeof STORYBOOK_REACT_CLASSES !== 'undefined') {
  STORYBOOK_REACT_CLASSES['src/ShortPageNavigator/index.js'] = {
    name: 'PageNavigator',
    docgenInfo: PageNavigator.__docgenInfo,
    path: 'src/ShortPageNavigator/index.js'
  };
}